/* eslint-disable quotes */
import escape from 'lodash-es/escape';

const impressions_sent = [];
const sendProductImpression = (variant, product, inventory) => {
  if (impressions_sent.indexOf(variant.barcode) > -1) {
    return;
  }
  impressions_sent.push(variant.barcode);

  const country = window.theme.country_iso;
  const quadpay_country = country === `US`;

  const active_price = variant.price;
  const active_compare_at_price = product.compare_at_price;

  const admind_product = {
    id: product.id,
    style: escape(variant.barcode),
    subcategory: escape(product.type),
    name: escape(product.title.replace(/((CLEARANCE)|(PLACEHOLDER))( - )/, '')),
    price: active_price,
    originalPrice: active_compare_at_price,
    newArrival: product.tags.includes('New Arrival'),
    isMarkedDown: Number(active_price) < Number(active_compare_at_price),
    showsQuadpay: quadpay_country && Number(active_price) > 14,
    // list: `Product`,
    position: 1,
    almostGone: inventory ? Number(inventory[variant.id]) < 10 : false,
    hasReviews: false,
    reviewCount: 0,
    reviewAverage: 0,
  };

  const dataLayer = window.dataLayer || [];

  dataLayer.push({
    event: `impressions`,
    ecommerce: {
      impressions: {
        products: [admind_product],
      },
    },
  });
};

export { sendProductImpression };
